module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/ma-gallery/ma-gallery-14-80e13a0389c32c00b237b45f27e194dd.jpg";